import Component from '~/components/component';

export default class Contact extends Component {
	_actionContactForm = 'sp_theme_send_email_contact_ajax';

	constructor(...args) {
		super(...args);

		this._retrieveDOM();
	}

	_retrieveDOM() {
		this.dom.form = this.dom.component.querySelector('.form');
		this.dom.submit = this.dom.component.querySelector('.submit');
		this.dom.loader = this.dom.component.querySelector('.contactLoader');
		this.dom.error = this.dom.component.querySelector('.error');
		this.dom.success = this.dom.component.querySelector('.success');
	}

	bind() {
		this.dom.form.addEventListener('submit', this.handleForm);
	}

	handleForm = (e) => {
		if (!this.dom.form.checkValidity()) {
			this.dom.form.reportValidity();
			return;
		}

		e.preventDefault();

		this.dom.success.classList.remove('visible');
		this.dom.submit.classList.add('disabled');
		this.dom.loader.classList.add('loading');

		const formData = new FormData(this.dom.form);
		this._request(formData);
	};

	/**
	 * Request "Form Contact Send"
	 * @param data (FormData)
	 */
	_request(data) {
		const xhr = new XMLHttpRequest();

		xhr.open(
			'POST',
			'/wp/wp-admin/admin-ajax.php?action=' + this._actionContactForm,
			true,
		);

		xhr.onreadystatechange = function () {
			if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
				this._response(JSON.parse(xhr.response));
			}
		}.bind(this);
		xhr.send(data);
	}

	/**
	 * Response to the request to send the form
	 * @param response Ajax
	 */
	_response(response) {
		this.dom.loader.classList.remove('loading');
		this.dom.submit.classList.remove('disabled');

		console.log(response);
		if (response.success) {
			this.dom.error.classList.remove('visible');
			this.dom.success.classList.add('visible');
			this.dom.form.reset();
		} else {
			console.log('error');
			this.dom.error.classList.add('visible');
		}
	}
}
